import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BookingTaxEstimateInterface } from '@sport-activities/sdk';
import { CheckoutItem } from '~/checkout/model/checkout-item.model';

@Component({
  selector: 'app-tax-included',
  templateUrl: './tax-included.component.html',
  styleUrls: ['./tax-included.component.scss'],
})
export class TaxIncludedComponent implements OnChanges {
  @Input() public isCart = false;
  @Input() public isVatDisplayed: boolean;
  @Input() public isVatShown: boolean;
  @Input() public item: CheckoutItem;
  @Input() public showExternalPayment: boolean;
  @Input() public taxes: BookingTaxEstimateInterface;
  @Input() public taxesDetail;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes?.taxes?.currentValue) {
      this.taxesDetail = changes.taxes.currentValue.details;
      this.getTaxesDetail();
    }
  }

  public getTaxesDetail() {
    this.taxesDetail = this.taxes?.details.find(
      (o) => o.sku === this.item?.timeslot.identifier
    );
    return this.taxesDetail?.offers[0]?.details[0];
  }
}
